import {
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
    grayColor
} from "../../material-dashboard-react";

const cardIconStyle = {
    cardIcon: {
        "&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader": {
            borderRadius: "3px",
            backgroundColor: grayColor[0],
            padding: "20px 0px",
            textAlign: "center",
            marginTop: "-20px",
            marginRight: "15px",
            float: "left",
            width: "60px",
            marginLeft: "-10px"
        }
    },
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader
};

export default cardIconStyle;


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/components/cardIconStyle.js